import nativeOttStarter from 'native-ott-json';
export default nativeOttStarter;